var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1009_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9098 8.81561C29.8368 7.21893 29.5832 6.1285 29.2124 5.17459C28.8358 4.17366 28.2454 3.26695 27.4823 2.51771C26.733 1.75452 25.8263 1.16394 24.8254 0.787148C23.8712 0.416543 22.7811 0.163184 21.1844 0.0906445C19.5848 0.0174023 19.0736 0 15 0C10.9264 0 10.4153 0.0174023 8.81561 0.0902344C7.21893 0.163184 6.12879 0.416777 5.17459 0.787559C4.17364 1.16417 3.26691 1.75464 2.51766 2.51777C1.75447 3.26693 1.16388 4.17355 0.78709 5.17441C0.416484 6.12861 0.163125 7.21898 0.0905859 8.81543C0.0174023 10.4153 0 10.9262 0 14.9998C0 19.0736 0.0174023 19.5847 0.0906445 21.1843C0.163418 22.7808 0.417012 23.8712 0.787793 24.8255C1.1644 25.8263 1.75485 26.733 2.51795 27.4821C3.26714 28.2452 4.17384 28.8357 5.17477 29.2122C6.12879 29.5832 7.21916 29.8366 8.81584 29.9096C10.4157 29.9826 10.9266 29.9998 15.0002 29.9998C19.0738 29.9998 19.585 29.9826 21.1846 29.9096C22.7813 29.8366 23.8714 29.5832 24.8256 29.2122C25.8221 28.8269 26.727 28.2376 27.4825 27.4822C28.2379 26.7268 28.8271 25.8218 29.2124 24.8254C29.5835 23.8712 29.8368 22.7808 29.9098 21.1844C29.9826 19.5845 30 19.0736 30 15C30 10.9262 29.9826 10.4153 29.9098 8.81561ZM27.2098 21.0615C27.1431 22.5241 26.8987 23.3183 26.6934 23.8468C26.4438 24.4937 26.0616 25.0812 25.5713 25.5715C25.081 26.0619 24.4935 26.4441 23.8465 26.6936C23.318 26.8989 22.5238 27.1434 21.0613 27.21C19.48 27.2823 19.0055 27.2974 15.0001 27.2974C10.9944 27.2974 10.5202 27.2823 8.93853 27.21C7.47627 27.1434 6.68209 26.8989 6.15334 26.6936C5.50185 26.4531 4.91253 26.0696 4.42869 25.5714C3.93045 25.0876 3.54699 24.4983 3.3065 23.8468C3.10119 23.3183 2.85674 22.5241 2.79012 21.0615C2.71805 19.48 2.7027 19.0055 2.7027 15.0003C2.7027 10.9948 2.71805 10.5206 2.79012 8.93877C2.85691 7.47627 3.10119 6.68203 3.3065 6.15357C3.54707 5.50203 3.93052 4.91264 4.42869 4.42869C4.91253 3.93044 5.50195 3.54704 6.15357 3.30674C6.68209 3.10119 7.47627 2.85697 8.93883 2.79012C10.5204 2.71805 10.9949 2.7027 15.0001 2.7027H14.9998C19.0051 2.7027 19.4795 2.71805 21.0613 2.79035C22.5238 2.85697 23.3179 3.10143 23.8465 3.30674C24.498 3.54728 25.0873 3.93064 25.5712 4.42869C26.0695 4.91252 26.4529 5.50195 26.6932 6.15357C26.8987 6.68209 27.1432 7.47627 27.2098 8.93883C27.2818 10.5204 27.2972 10.9949 27.2972 15.0001C27.2972 19.0055 27.2821 19.4797 27.2098 21.0615Z",
    fill: "url(#paint0_linear_1009_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9997 7.29727C10.7457 7.29727 7.29712 10.746 7.29712 15C7.29712 19.254 10.7457 22.7026 14.9997 22.7026C19.2539 22.7026 22.7025 19.254 22.7025 15C22.7025 10.746 19.2539 7.29727 14.9997 7.29727ZM14.9997 19.9999C12.2384 19.9997 9.99976 17.7612 9.99999 14.9998C9.99999 12.2385 12.2384 9.99985 14.9999 9.99985C17.7614 10.0001 19.9998 12.2385 19.9998 14.9998C19.9998 17.7612 17.7611 19.9999 14.9997 19.9999Z",
    fill: "url(#paint1_linear_1009_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8068 6.99305C24.8068 7.98709 24.0009 8.79293 23.0069 8.79293C22.0127 8.79293 21.2068 7.98703 21.2068 6.99305C21.2068 5.99871 22.0127 5.19287 23.0069 5.19287C24.0009 5.19287 24.8069 5.99877 24.8069 6.99305H24.8068Z",
    fill: "url(#paint2_linear_1009_2)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1009_2",
    x1: 2.51754,
    y1: 27.4822,
    x2: 27.4825,
    y2: 2.5173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF0100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D800B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1009_2",
    x1: 9.55321,
    y1: 20.4465,
    x2: 20.4464,
    y2: 9.55331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF0100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD0056"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1009_2",
    x1: 21.7341,
    y1: 8.2657,
    x2: 24.2796,
    y2: 5.72016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F30072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E50097"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1009_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.908eb3a6555b69e94496d2576ccdbf40.svg";
export { ForwardRef as ReactComponent };